import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createAmortizationReportApi(params: any) {
  let apiData: any = {
    startDate: params.startDate,
    endDate: params.endDate,
    programExternalId: params.programmeId.length ? params.programmeId : null,
    customerExternalId: params.customerId.length ? params.customerId : null,
    saveReport: params.saveReport
  };
  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/amortization-report`;
  return api.create(`${backendApiUrl}`, apiData);
}

export { createAmortizationReportApi };